import type { ProductProjection } from "@commercetools/platform-sdk";
import { fetchFromCTWithSession } from "./frontend-session";

const projectKey = process.env.GATSBY_COMMERCETOOLS_PROJECT_KEY;
const storeKey = process.env.GATSBY_STORE;

export const fetchGiftBox = async (): Promise<
	ProductProjection | undefined
> => {
	let response: ProductProjection | undefined;

	try {
		const returnData = await fetchFromCTWithSession<ProductProjection>(
			`${projectKey}/in-store/key=${storeKey}/product-projections/key=gift-box`,
		);
		response = returnData.data;
	} catch (error) {
		console.error(error);
	}

	return response;
};

export const fetchGiftMessage = async (): Promise<
	ProductProjection | undefined
> => {
	let response: ProductProjection | undefined;

	try {
		const returnData = await fetchFromCTWithSession<ProductProjection>(
			`${projectKey}/in-store/key=${storeKey}/product-projections/key=gift-message`,
		);
		response = returnData.data;
	} catch (error) {
		console.error(error);
	}

	return response;
};
